type ReadableArray<T> = ReadonlyArray<T> | T[];

/**
 * Check to see if the value exists in the array. Value comparision uses strict equality (===).
 *
 * @param arr - The source array to search
 * @param value - The value to search for
 * @returns Whether or not the item exists in the array
 */
export function contains<T>(arr: ReadableArray<T>, value: T): boolean {
    return arr.includes(value);
}
